import { compose } from 'recompose'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import {
  selectPrequalRequestSuccess,
  selectPrequalRequestFailure,
} from '../../../../../store/selectors/affordability'
import { selectContactFirstName } from '../../../../../store/selectors/contact'
import { toggleAffordabilityModal } from '../../../../../actions/affordability'

const PrequalRequestedContainer = compose(
  connect(
    state => ({
      name: selectContactFirstName(state),
      success: selectPrequalRequestSuccess(state),
      error: selectPrequalRequestFailure(state),
    }),
    dispatch => ({
      onClose: () => dispatch(toggleAffordabilityModal()),
    })
  ),
  injectIntl
)

export default PrequalRequestedContainer
